package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

@Composable
actual fun DialogButtonRow(
    confirmButtonText: String?,
    onConfirmClick: () -> Unit,
    confirmEnabled: Boolean,
    confirmLoading: Boolean,
    dismissButtonText: String?,
    onDismissClick: () -> Unit,
    neutralButtonText: String?,
    onNeutralClick: () -> Unit,
) {
    Row(modifier = Modifier.fillMaxWidth()) {
        if (neutralButtonText != null) {
            Button(
                onClick = onNeutralClick,
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.background,
                    contentColor = MaterialTheme.colorScheme.error
                )
            ) {
                Text(neutralButtonText)
            }
        }

        Spacer(modifier = Modifier.weight(1f))

        if (dismissButtonText != null) {
            Button(
                onClick = onDismissClick,
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.background,
                    contentColor = MaterialTheme.colorScheme.tertiary
                )
            ) {
                Text(dismissButtonText)
            }
            Spacer(modifier = Modifier.width(16.dp))
        }

        if (confirmButtonText != null) {
            Button(
                onClick = onConfirmClick,
                enabled = confirmEnabled && !confirmLoading,
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.tertiary,
                    contentColor = MaterialTheme.colorScheme.onTertiary,
                    disabledContainerColor = MaterialTheme.colorScheme.tertiary,
                    disabledContentColor = MaterialTheme.colorScheme.onTertiary
                )
            ) {
                Box(contentAlignment = Alignment.Center) {
                    if (confirmLoading) {
                        CircularProgressIndicator(
                            modifier = Modifier.size(20.dp),
                            color = MaterialTheme.colorScheme.onTertiary
                        )
                    }
                    Text(
                        text = confirmButtonText,
                        color = if (confirmLoading) Color.Transparent
                        else MaterialTheme.colorScheme.onTertiary
                    )
                }
            }
        }
    }
}
